// ============================================
// Main App Component
// ============================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress WebSocket connection errors from webpack-dev-server
// These are harmless warnings when dev server is not running or hot reload fails
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    // Filter out webpack-dev-server WebSocket connection errors
    if (
      args[0]?.includes?.('WebSocket connection to') ||
      args[0]?.includes?.('ERR_CONNECTION_REFUSED') ||
      args[0]?.includes?.('WebSocketClient')
    ) {
      return; // Suppress these warnings
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
